import { useMutation } from '@tanstack/react-query';
import { aiAgentApis } from '../../../../../../../shared/apis/ai-agent/apis';
import type { IAsUploadUrlParams } from '../../../../../../../shared/apis/ai-agent/ascs/type';

export default function usePostPresignedUrl() {
  return useMutation((data: IAsUploadUrlParams) => aiAgentApis.ascs.getAsUploadUrl(data));
}
